import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { environment } from '@environments/environment';
import {
  AssociateRecipeRequest,
  ConsumptionWarehouseLocation,
  ProductionCardDyeingCycleRecipeValues,
  RecipePreview,
} from '@app/models/dyeing-dashboard/production-card-dyeing-cycle-recipe-values';

@Injectable({
  providedIn: 'root',
})
export class ProductionCardDyeingCycleRecipeValuesProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/production-card-dyeing-cycle';

  getAvailableRecipes(cycleId: string): Observable<ApiResponse<RecipePreview[]>> {
    return this.httpClient.get<ApiResponse<RecipePreview[]>>(`${this.baseUrl}/${cycleId}/available-recipes`);
  }

  getConsumptionWarehouse(): Observable<ApiResponse<ConsumptionWarehouseLocation | null>> {
    return this.httpClient.get<ApiResponse<ConsumptionWarehouseLocation | null>>(`${this.baseUrl}/recipe-values/consumption-warehouse`);
  }

  associateRecipe(cycleId: string, request: AssociateRecipeRequest): Observable<ApiResponse<ProductionCardDyeingCycleRecipeValues>> {
    return this.httpClient.post<ApiResponse<ProductionCardDyeingCycleRecipeValues>>(`${this.baseUrl}/${cycleId}/recipe`, request);
  }

  getRecipeValues(cycleId: string): Observable<ApiResponse<ProductionCardDyeingCycleRecipeValues>> {
    return this.httpClient.get<ApiResponse<ProductionCardDyeingCycleRecipeValues>>(`${this.baseUrl}/${cycleId}/recipe-values`);
  }

  updateRecipeValues(
    cycleId: string,
    recipeValues: ProductionCardDyeingCycleRecipeValues,
  ): Observable<ApiResponse<ProductionCardDyeingCycleRecipeValues>> {
    return this.httpClient.put<ApiResponse<ProductionCardDyeingCycleRecipeValues>>(
      `${this.baseUrl}/${cycleId}/recipe-values`,
      recipeValues,
    );
  }

  completeRecipeValues(cycleId: string): Observable<ApiResponse<ProductionCardDyeingCycleRecipeValues>> {
    return this.httpClient.put<ApiResponse<ProductionCardDyeingCycleRecipeValues>>(`${this.baseUrl}/${cycleId}/recipe-values/complete`, {});
  }
}
